import PropTypes from "prop-types";
import { connect } from "react-redux";
import values from "lodash/values";
import {
	setProductsFilter,
	setProductsFilters,
	unsetProductsFilter,
} from "app/pages/Listing/ProductFilters/productsFilterActionCreators";
import {
	getBadgeFilterValues,
	getDestinationFilterValues,
	getMonthFilterValues,
	getSelectedFacets,
	getTopicFilterValues,
	getVisibleFilters,
	shouldDisplayDestinationFilter,
} from "app/pages/Listing/productsSelector";
import { bindActionCreators } from "redux";
import syncFiltersWithUrl from "app/pages/Listing/ProductFilters/syncFiltersWithUrl";

const ProductsFilterComponent = props => {
	const { productsFilters = {}, setProductsFilters, renderComponent } = props;

	syncFiltersWithUrl(productsFilters, setProductsFilters);

	return renderComponent(props);
};

ProductsFilterComponent.propTypes = {
	renderComponent: PropTypes.func,
};

const mapStateToProps = state => {
	const products = state.products;
	return {
		productsFilters: state.productsFilters,
		productsActiveFilters: values(state.productsFilters),
		visibleFilters: getVisibleFilters(state),
		selectedFacets: getSelectedFacets(state),
		destinationFilterValues: getDestinationFilterValues(state),
		topicFilterValues: getTopicFilterValues(state),
		monthsFilterValues: getMonthFilterValues(state),
		badgesFilterValues: getBadgeFilterValues(state),
		displayFilters: products.length !== 0,
		displayDestinationFilter: shouldDisplayDestinationFilter(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{ setProductsFilter, setProductsFilters, unsetProductsFilter },
		dispatch
	);
};

export const ProductsFilterContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(ProductsFilterComponent);
